
import { defineComponent, ref } from 'vue';
import { ChevronDown } from '@vicons/fa';
import { http } from '../services';
import { HoundModel } from '../../../common';
import LeaderboardListItem from './LeaderboardListItem.vue';

export default defineComponent({
  name: 'BreedingLeaderboard',
  components: { LeaderboardListItem, ChevronDown },
  setup () {
    let iteration = ref(1);
    const items = ref<any[]>([]);
    const resetLeaderboard = (): void => {
      http.getBreedingLeaderboard(50, (iteration.value - 1) * 50)
        .then((res: any[]) => {
          res.forEach((item, index) => {
            items.value.push({
              ...new HoundModel({
                id: Number(item.id),
                name: item.name,
                geneticSequence: item.geneticSequence,
                extensionTraits: item.extensionTraits,
                firstPlace: item.firstPlace,
                secondPlace: item.secondPlace,
                thirdPlace: item.thirdPlace,
                owner: item.owner
              }),
              score: item.score
            });
          });
        });
    };
    const loadMore = () => {
      iteration.value++;
      resetLeaderboard()
    };

    resetLeaderboard();

    return {
      items,
      loadMore
    };
  }
});
